import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "@/components/SiteChrome";
import api from "@/lib/api";

export default function Collections() {
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        api.get("/brands").then(({ data }) => setBrands(data.brands));
    }, []);

    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="collections-page">
            <Header />
            <div className="border-b-2 border-[hsl(var(--ink))] bg-[hsl(var(--dust-300))] text-[hsl(var(--dust-50))]">
                <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
                    <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--dust-100))]">Collections</div>
                    <h1 className="mt-2 font-display text-5xl uppercase italic md:text-7xl">Shop by vehicle.</h1>
                    <p className="mt-4 max-w-2xl text-[hsl(var(--dust-100))]">
                        Pick your rig. We'll show you the parts that fit, plus the universal gear every off-road build needs.
                    </p>
                </div>
            </div>

            <div className="mx-auto grid max-w-7xl gap-6 px-4 py-12 sm:px-6 md:grid-cols-2">
                {brands.map((b) => (
                    <Link
                        key={b.slug}
                        to={`/collections/${b.slug}`}
                        className="group relative flex flex-col justify-between overflow-hidden border-2 border-[hsl(var(--ink))] bg-card p-8 transition-transform hover:-translate-y-1"
                        data-testid={`brand-${b.slug}`}
                    >
                        <div className="absolute -right-8 -top-10 font-display text-[10rem] uppercase italic leading-none text-[hsl(var(--dust-100))] transition-colors group-hover:text-[hsl(var(--dust-300))]">
                            {b.name}
                        </div>
                        <div className="relative">
                            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">
                                {b.count} parts ready
                            </div>
                            <h2 className="mt-2 font-display text-5xl uppercase italic text-[hsl(var(--ink))]">{b.name}</h2>
                            <p className="mt-2 font-heading text-sm uppercase tracking-wider text-[hsl(var(--rust))]">
                                {b.tagline}
                            </p>
                        </div>
                        <p className="relative mt-10 max-w-md text-sm text-[hsl(var(--ink-soft))]">{b.blurb}</p>
                        <div className="relative mt-6 font-heading text-sm uppercase tracking-wider text-[hsl(var(--ink))] underline-offset-8 group-hover:underline">
                            Shop the {b.name} collection →
                        </div>
                    </Link>
                ))}
            </div>
            <Footer />
        </div>
    );
}
